module.exports = __webpack_public_path__ + "media/Hilfevideo_LBST_Gruppen_B.4f9c6ac5.mp4";